import { render, staticRenderFns } from "./vipStatus.vue?vue&type=template&id=25b1861b&scoped=true"
import script from "./vipStatus.vue?vue&type=script&lang=js"
export * from "./vipStatus.vue?vue&type=script&lang=js"
import style0 from "./vipStatus.vue?vue&type=style&index=0&id=25b1861b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1861b",
  null
  
)

export default component.exports